import React, { useState, useEffect, useRef } from "react";
import "./SearchBar.css";
import { FiSearch, FiSliders, FiCheck } from "react-icons/fi";

const SORT_OPTIONS = [
  { value: "", label: "Default" },
  { value: "asc", label: "Price: Low to High" },
  { value: "desc", label: "Price: High to Low" },
];

const SearchBar = ({ searchValue, setSearchValue, priceSort = "", setPriceSort }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="premium-search-container">
      <div className="premium-search-inner">
        <FiSearch className="premium-search-icon" />
        <input
          type="text"
          className="premium-search-input"
          placeholder="What are you craving?"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>
      {setPriceSort && (
        <div className="price-filter-wrap" ref={wrapRef}>
          <button
            type="button"
            className={`price-filter-btn ${priceSort ? "active" : ""}`}
            onClick={() => setOpen((o) => !o)}
            aria-label="Sort by price"
          >
            <FiSliders />
          </button>
          {open && (
            <div className="price-filter-menu">
              {SORT_OPTIONS.map((opt) => (
                <div
                  key={opt.value}
                  className={`price-filter-option ${priceSort === opt.value ? "selected" : ""}`}
                  onClick={() => {
                    setPriceSort(opt.value);
                    setOpen(false);
                  }}
                >
                  {opt.label}
                  {priceSort === opt.value && <FiCheck />}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
